<template>

    <v-card
            elevation="0"
            class="payment-dialog"
    >

        <div class="modal-close-btn">
            <v-btn icon @click="$emit('hideDialog')">
                <v-icon size="18" color="grey">mdi-close</v-icon>
            </v-btn>
        </div>

        <v-card-text class="pa-6 px-12">

            <form id="payment-form">

                <v-row>
                    <v-col>
                        <h4 class="funds-title">Your Details</h4>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col cols="12" md="6" class="pb-0">
                        <v-text-field label="Full Name"
                                      outlined
                                      v-model="donation.donor_name"
                                      :error-messages="nameErrors"
                                      @input="$v.donation.donor_name.$touch()"
                                      @blur="$v.donation.donor_name.$touch()"
                                      :disabled="isCallingApi"
                                      class="btn-edu-height"
                                      hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                                label="Email Address"
                                outlined
                                v-model="donation.donor_email"
                                :error-messages="emailErrors"
                                @input="$v.donation.donor_email.$touch()"
                                @blur="$v.donation.donor_email.$touch()"
                                :disabled="isCallingApi"
                                class="btn-edu-height"
                                hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pt-0">
                        <v-checkbox
                                    v-model="donation.is_anonymous"
                        >
                            <template slot="label">
                                <span>Show me as anonymous</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

                <v-row class="justify-space-between">
                    <v-col cols="12" md="12" class="pb-0 d-flex justify-space-between flex-column flex-sm-row">
                        <h4 class="funds-title mb-4">Payment Information</h4>
                        <v-spacer></v-spacer>
                        <v-img src="@/assets/icons/cards.png" max-width="143" min-width="143" min-height="23" max-height="23" contain></v-img>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <v-text-field label="Name on Card"
                                      outlined
                                      v-model="donation.cardFullName"
                                      :error-messages="cardNameErrors"
                                      @input="$v.donation.cardFullName.$touch()"
                                      @blur="$v.donation.cardFullName.$touch()"
                                      :disabled="isCallingApi"
                                      class="btn-edu-height"
                                      hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-4 pt-4">
                        <div id="card-element">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>
                        <!-- Used to display form errors. -->
                        <div id="card-errors" role="alert"></div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="pb-0">
                        <h4>Summary</h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card
                                elevation="0"
                                outlined
                                color="#f4f5f6"
                                class="px-6 d-flex align-center summary"
                                :height="$vuetify.breakpoint.smAndUp?61:'auto'"
                        >
                            <v-row class="d-flex flex-column flex-sm-row">
                                <v-col cols="12" sm="10" class="d-flex align-center justify-center justify-sm-start">Amount to be added to {{user.name}}'s account:</v-col>
                                <v-col cols="12" sm="2" class="d-flex align-center justify-sm-end justify-center"><strong>${{amount}}</strong></v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col>
                        <v-card
                                elevation="0"
                                outlined
                                color="#f4f5f6"
                                class="px-6 d-flex align-center summary"
                                :height="$vuetify.breakpoint.smAndUp?61:'auto'"
                        >
                            <v-row class="d-flex flex-column flex-sm-row">
                                <v-col cols="12" sm="10" class="d-flex align-center justify-center justify-sm-start">Destination Fee charged to the Donor:</v-col>
                                <v-col cols="12" sm="2" class="d-flex align-center justify-sm-end justify-center"><strong>${{destinationFee}}</strong></v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="pb-0">
                        <h5>Leave a public note</h5>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pb-0">
                        <v-textarea
                                label="Your message"
                                outlined
                                flat
                                solo
                                rows="4"
                                v-model="donation.donor_note"
                                :disabled="isCallingApi"
                                no-resize
                                class="btn-edu-height"
                                hide-details="auto"
                        ></v-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="pt-0">
                        <v-checkbox v-model="isAgreedTermsAndConditions"
                                    :error-messages="isAgreedTermsAndConditionsErrors"
                                    @change="$v.isAgreedTermsAndConditions.$touch()"
                        >
                            <template slot="label">
                                <span>
                                    I agree to the
                                  <a @click="openUrl">
                                    terms and conditions
                                  </a>
                                  of EDUrent
                                </span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pt-0 d-flex justify-center justify-md-start">
                        <v-btn
                                color="primary"
                                @click="confirmCardPayment"
                                :loading="isCallingApi"
                                depressed
                                class="btn-edurent"
                                height="45"
                                width="205"
                        >
                            Process Payment
                        </v-btn>
                    </v-col>
                </v-row>

            </form>

        </v-card-text>

    </v-card>

</template>

<script>
    import {email, required, sameAs } from 'vuelidate/lib/validators'
    import PaymentService from "../services/payment.service";
    import {calculateDestinationFee} from "../utils/helpers";

    export default {
        name: 'MyCampaignPayment',
        props: ['campaign', 'amount', 'clientSecret'],
        validations: {
            donation: {
                donor_name: { required },
                donor_email: { email, required },
                cardFullName: { required }
            },
            isAgreedTermsAndConditions: { sameAs: sameAs(() => true)}
        },
        data: () => ({
            stripe: null,
            card: null,
            isCallingApi: false,
            donation: {},
            isAgreedTermsAndConditions: false
        }),
        computed: {
            destinationFee() {
                let destinationFee = calculateDestinationFee(this.amount);

                return destinationFee.toFixed(2);
            },
            user() {
                return this.$store.getters.getUser;
            },
            nameErrors () {
                const errors = []
                if (!this.$v.donation.donor_name.$dirty) return errors;
                !this.$v.donation.donor_name.required && errors.push('Fullname is required');
                if (!this.isFullName(this.$v.donation.donor_name.$model)) {
                    errors.push('Your firstname and lastname is required');
                }
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.donation.donor_email.$dirty) return errors;
                if (!this.validEmail(this.$v.donation.donor_email.$model)) {
                    errors.push('A valid email is required');
                }
                !this.$v.donation.donor_email.required && errors.push('Email is required');
                return errors
            },
            cardNameErrors () {
                const errors = []
                if (!this.$v.donation.cardFullName.$dirty) return errors;
                !this.$v.donation.cardFullName.required && errors.push('Name on card is required');
                return errors
            },
            isAgreedTermsAndConditionsErrors() {
                const errors = []
                if (!this.$v.isAgreedTermsAndConditions.$dirty) return errors;
                !this.$v.isAgreedTermsAndConditions.sameAs && errors.push('You must agree to the terms and conditions');
                return errors
            }
        },
        methods: {
            isFullName(name) {
                return name.trim().split(' ').length > 1
            },
            validEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            confirmCardPayment: async function() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$store.commit('setSnackbar', {
                        show: true,
                        message: 'Mandatory field is missing. Please enter it on the highlighted field',
                        color: 'red'
                    });

                    return;
                }

                this.isCallingApi = true;
                const response = await this.stripe.confirmCardPayment(
                    this.clientSecret,
                    {
                        payment_method: {
                            card: this.card,
                            billing_details: {
                                name: this.donation.cardFullName,
                            },
                        },
                    }
                );

                this.isCallingApi = false;

                if (response.paymentIntent.status !== 'succeeded') {
                    this.$store.commit('setSnackbar', {
                        show: true,
                        message: 'An error occurred while processing your payment details. Please try again or contact your consultant.',
                        color: 'red'
                    });

                    return
                }

                this.donation.amount = this.amount*100;
                this.donation.destination_fee = calculateDestinationFee(this.amount).toFixed(2)*100;

                this.isCallingApi = true;
                await PaymentService.addDonor({donation: this.donation});
                this.isCallingApi = false;

                this.initDonor();
                this.$emit('paymentCompleted');
            },
            initDonor() {
                this.$v.$reset();
                this.donation = {
                    user_id: this.campaign.user_id,
                    campaign_id: this.campaign.id,
                    donor_name: '',
                    donor_email: '',
                    is_anonymous: false,
                    cardFullName: '',
                    donor_note: '',
                    amount: '',
                    destination_fee: ''
                }
            },
            openUrl() {
              let route = this.$router.resolve({name: 'Terms'});
              window.open(route.href, '_blank');
            }
        },
        beforeMount() {
            this.initDonor();
        },
        mounted: function () {
            // Create a Stripe client.
            this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);

            // Create an instance of Elements.
            const elements = this.stripe.elements();

            const style = {
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };

            // Create an instance of the card Element.
            this.card = elements.create('card', {style: style});

            // Add an instance of the card Element into the `card-element` <div>.
            this.card.mount('#card-element');
        }
    }
</script>

<style scoped>
    /**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
    .StripeElement {
        box-sizing: border-box;

        height: 50px;

        padding: 10px 12px;

        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;

        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .payment-dialog h4 {
        font-size: 20px !important;
        font-weight: 700;
        color: #000;
    }
    .payment-dialog h5 {
        font-size: 14px !important;
        color: #000;
    }
    .payment-dialog .v-input--checkbox label span {
        font-size: 14px !important;
    }
    .payment-dialog .summary {
        border-color: #d8d8d8 !important;
    }
    .payment-dialog {
        border-radius: 10px !important;
    }

</style>
